<template>
    <div class="alert" id="alert">
        <div class="alert_card" :class="{'ac-bg-gray': ac}">
            <div class="alert_close">
                <button v-if="closeButtonActive" :class="{'information_btn_close-ac': ac, 'information_btn_close': !ac}" @click.prevent="$emit('close')"></button>
            </div>
            <section class="alert_type">
                <i id="icon_modal" :class="{ 'alert_success' : success, 'alert_danger': danger, 'alert_warning': warning}" v-if="!ac"></i>
                <i id="icon_modal" :class="{ 'ac-alert_success' : success, 'ac-alert_danger': danger, 'ac-alert_warning': warning}" v-if="ac"></i>
            </section>
            <h2 class="alert_description" id="alert_description" v-html="description" :class="{'ac-color-white': ac}"></h2>
            <p class="alert_message" id="alert_message" v-html="message" :class="{'ac-color-white': ac}"></p>
            <div class="alert_container_button">
                <button class="alert_btn_close_button" :class="{'ac-color-black': ac, 'ac-bg-yellow': ac}" @click.prevent="mainButtonTrigger">{{ action }}</button>
                <button class="alert_btn_close_button border_button" :class="{'ac-color-black': ac, 'ac-bg-yellow': ac}" @click.prevent="secondaryButtonTrigger" v-if="secondaryAction">{{ secondaryAction }}</button>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "Alert",
        props: {
            success: {
                default: false
            },
            closeButtonActive: {
                default: true
            },
            danger: {
                default: false
            },
            warning: {
                default: false
            },
            description: {
                default: "Sucesso"
            },
            message: {
                default: ""
            },
            action: {
                default: "Fechar"
            },
            secondaryAction: {
                default: null   
            },
            tracker: {
                default: null
            },
            actionMessage: {
                default: "Fechar"
            }
        },
        data() {
            return {}
        },
        computed: mapState({
            ac: state => state.ac,
            customer: state => state.customer,
            anotherBrandModalMessage: state => state.config.anotherBrandModalMessage,
           
        }),
        methods: {
            mainButtonTrigger() {
                this.$emit('mainButtonTrigger');
            },
            secondaryButtonTrigger() {
                this.$emit('secondButtonTrigger')
            },
            closeAlert() {
                if(this.tracker) this.dispachEventTrack(this.tracker)
                this.$emit('close')
            }
        }
    }
</script>

<style lang="scss" scoped>
    .alert {
        width: 100%;
        height: 100vh;
        display: flex;
        align-items: center;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1005;
        background: rgba(0,0,0,0.6);
        overflow-y: auto;
        > .alert_card {
            width: 335px;
            min-height: 526px;
            position: relative;
            display: block;
            margin: 0 auto;
            border-radius: 16px;
            box-shadow: 0 24px 50px 0 rgba(0, 0, 0, 0.2);
            background-color: #ffffff;
            > .alert_close {
                width: 100%;
                height: 17px;
                margin: 25px auto;
                display: block;
                position: relative;
                z-index: 2;
                > .alert_btn_close {
                    width: 17px;
                    height: 17px;
                    float: right;
                    display: block;
                    position: relative;
                    z-index: 3;
                    background: url("../assets/images/close.svg") no-repeat;
                    border: 0;
                    margin-right: 25px;
                }
                > .information_btn_close {
                    width: 17px;
                    height: 17px;
                    float: right;
                    display: block;
                    position: relative;
                    z-index: 3;
                    background: url("../assets/images/close.svg") no-repeat;
                    border: 0;
                    margin-right: 25px;
                }
                > .information_btn_close-ac {
                    width: 17px;
                    height: 17px;
                    float: right;
                    display: block;
                    position: relative;
                    z-index: 3;
                    background: url("../assets/images/close-ac.png") no-repeat !important;
                    border: 0;
                    margin-right: 25px;
                }
            }
            > .alert_type {
                width: 100%;
                height: 60px;
                display: block;
                position: relative;
                margin-top: 40px;
                > .alert_success {
                    width: 60px;
                    height: 60px;
                    display: block;
                    position: relative;
                    margin: 0 auto;
                    border-radius: 60px;
                    background: url("../assets/images/path.png") no-repeat;
                    background-position: center;
                }
                > .ac-alert_success {
                    width: 60px;
                    height: 60px;
                    display: block;
                    position: relative;
                    margin: 0 auto;
                    border-radius: 60px;
                    background: url("../assets/images/path-ac.png") no-repeat;
                    background-position: center;
                }
                > .ac-alert_danger {
                    width: 60px;
                    height: 60px;
                    display: block;
                    position: relative;
                    margin: 0 auto;
                    border-radius: 60px;
                    background: url("../assets/images/danger-ac.svg") no-repeat;
                    background-position: center;
                }
                > .alert_danger {
                    width: 60px;
                    height: 60px;
                    display: block;
                    position: relative;
                    margin: 0 auto;
                    border-radius: 60px;
                    background: url("../assets/images/danger.svg") no-repeat;
                    background-position: center;
                }
                > .alert_warning {
                    width: 60px;
                    height: 60px;
                    display: block;
                    position: relative;
                    margin: 0 auto;
                    border-radius: 60px;
                    background: url("../assets/images/notifications-alert-circle.svg") no-repeat;
                    background-position: center;
                }
                > .ac-alert_warning {
                    width: 60px;
                    height: 60px;
                    display: block;
                    position: relative;
                    margin: 0 auto;
                    border-radius: 60px;
                    background: url("../assets/images/ic-exclamation-ac.svg") no-repeat;
                    background-position: center;
                }
            }
            > .alert_description {
                width: 90%;
                min-height: 10px;
                margin: 37px auto 0 auto;
                font-family: 'timsans_thin';
                font-size: 2em;
                font-weight: 600;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                text-align: center;
                color: #000000;
            }
            > .alert_message {
                width: 240px;
                min-height: 10px;
                display: block;
                margin: 24px auto 0 auto;
                font-family: 'timsans_regular';
                font-size: 1em;
                line-height: 1.5;
                letter-spacing: -0.2px;
                text-align: center;
                color: #666666;
            }
            > .alert_container_button {
                width: 100%;
                height: auto;
                display: block;
                position: relative;
                margin-top: 40px;
                > .alert_btn_close_button {
                    width: 286px;
                    min-height: 52px;
                    margin: 0 auto;
                    padding: 16px 0;
                    position: relative;
                    display: grid;
                    border-radius: 26px;
                    box-sizing: border-box;
                    background-color: #003091;
                    color: #ffffff;
                    border: none;
                    font-family: 'timsans_regular';
                    font-size: 1em;
                    text-align: center;
                }
                > .alert_btn_close_button.border_button {
                    background: transparent;
                    border: 1px solid #003091;
                    color: #003091;
                    margin: 24px auto;
                }
            }
        }
    }
    @media (min-width: 768px) {
        .alert {
            width: 100%;
            height: 100vh;
            display: flex;
            align-items: center;
            position: fixed;
            top: 0;
            left: 0;
            z-index: 1005;
            background: rgba(0,0,0,0.6);
            overflow-y: auto;
            > .alert_card {
                width: 482px;
                min-height: 426px;
                position: relative;
                display: block;
                margin: 0 auto;
                border-radius: 16px;
                box-shadow: 0 24px 50px 0 rgba(0, 0, 0, 0.2);
                background-color: #ffffff;
                padding-bottom: 2.5rem;
                
                > .alert_close {
                    width: 100%;
                    height: 17px;
                    margin: 25px auto;
                    display: block;
                    position: relative;
                    z-index: 2;
                    > .alert_btn_close {
                        width: 17px;
                        height: 17px;
                        float: right;
                        display: block;
                        position: relative;
                        z-index: 3;
                        background: url("../assets/images/close.svg") no-repeat;
                        border: 0;
                        margin-right: 25px;
                    }
                    > .information_btn_close {
                        width: 17px;
                        height: 17px;
                        float: right;
                        display: block;
                        position: relative;
                        z-index: 3;
                        background: url("../assets/images/close.svg") no-repeat;
                        border: 0;
                        margin-right: 25px;
                    }
                    > .information_btn_close-ac {
                        width: 17px;
                        height: 17px;
                        float: right;
                        display: block;
                        position: relative;
                        z-index: 3;
                        background: url("../assets/images/close-ac.png") no-repeat !important;
                        border: 0;
                        margin-right: 25px;
                    }
                }
                > .alert_type {
                    width: 100%;
                    height: 60px;
                    display: block;
                    position: relative;
                    margin-top: 40px;
                    > .alert_success {
                        width: 60px;
                        height: 60px;
                        display: block;
                        position: relative;
                        margin: 0 auto;
                        border-radius: 60px;
                        background: url("../assets/images/path.png") no-repeat;
                        background-position: center;
                    }
                    > .ac-alert_success {
                        width: 60px;
                        height: 60px;
                        display: block;
                        position: relative;
                        margin: 0 auto;
                        border-radius: 60px;
                        background: url("../assets/images/path-ac.png") no-repeat;
                        background-position: center;
                    }
                    > .ac-alert_danger {
                        width: 60px;
                        height: 60px;
                        display: block;
                        position: relative;
                        margin: 0 auto;
                        border-radius: 60px;
                        background: url("../assets/images/danger-ac.svg") no-repeat;
                        background-position: center;
                    }
                    > .alert_danger {
                        width: 60px;
                        height: 60px;
                        display: block;
                        position: relative;
                        margin: 0 auto;
                        border-radius: 60px;
                        background: url("../assets/images/danger.svg") no-repeat;
                        background-position: center;
                    }
                    > .alert_warning {
                        width: 60px;
                        height: 60px;
                        display: block;
                        position: relative;
                        margin: 0 auto;
                        border-radius: 60px;
                        background: url("../assets/images/ic-exclamation.svg") no-repeat;
                        background-position: center;
                    }
                    > .ac-alert_warning {
                        width: 60px;
                        height: 60px;
                        display: block;
                        position: relative;
                        margin: 0 auto;
                        border-radius: 60px;
                        background: url("../assets/images/ic-exclamation-ac.svg") no-repeat;
                        background-position: center;
                    }
                }
                > .alert_description {
                    width: 366px;
                    min-height: 10px;
                    margin: 37px auto 0 auto;
                    font-family: 'timsans_thin';
                    font-size: 2em;
                    font-weight: 600;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    text-align: center;
                    color: #000000;
                }
                > .alert_message {
                    width: 366px;
                    min-height: 10px;
                    display: block;
                    margin: 24px auto 0 auto;
                    font-family: 'timsans_regular';
                    font-size: 1em;
                    line-height: 1.5;
                    letter-spacing: -0.2px;
                    text-align: center;
                    color: #666666;
                }
                > .alert_container_button {
                    width: 100%;
                    height: auto;
                    display: block;
                    position: relative;
                    margin-top: 40px;
                    > .alert_btn_close_button {
                        width: 286px;
                        min-height: 52px;
                        margin: 0 auto;
                        padding: 16px 0;
                        position: relative;
                        display: grid;
                        border-radius: 26px;
                        box-sizing: border-box;
                        background-color: #003091;
                        color: #ffffff;
                        border: none;
                        font-family: 'timsans_regular';
                        font-size: 1em;
                        text-align: center;
                    }
                }
            }
        }
    }
</style>